import {offWhite} from "./colors";

//region Form
const formStandaloneLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 8},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
        lg: {span: 10},
        xxl: {span: 8},
    },
    colon: false,
}

const formCompanyDataLayout = {
    labelCol: {
        xs: {span: 24},
        sm: {span: 12},
        lg: {span: 12},
        xxl: {span: 12},
    },
    wrapperCol: {
        xs: {span: 24},
        sm: {span: 10},
        lg: {span: 10},
        xxl: {span: 10},
    },
    colon: false,
}

const formInCardLayout = {
    labelCol: {span: 24},
    wrapperCol: {span: 24},
    colon: false,
}

const formItemSubmitButtonStyle = {
    wrapperCol: {
        xs: {span: 24, offset: 0},
        sm: {span: 16, offset: 8},
    }
}

const formItemEditorStyle = {
    wrapperCol: {
        lg: {span: 10},
    },
}

const formItemFullWidth = {
    width: '100%',
}
//endregion

const inlineButton = {
    padding: 0,
    height: 20,
};

const listGridStyle = {
    gutter: 16,
    xs: 1,
    sm: 2,
    md: 2,
    lg: 3,
    xl: 4,
    xxl: 5,
}

const bookingListGridStyle = {
    gutter: 16,
    xs: 1,
    md: 2,
    xl: 3,
}

const jailListGridStyle = {
    gutter: 16,
    xs: 1,
    sm: 1,
    md: 2,
    lg: 2,
    xl: 3,
    xxl: 3,
}

const staffActionColSize = {
    xs: 24,
    sm: 12,
    md: 12,
    lg: 8
}

const cardsGridColumn = {
    xs: 24,
    sm: 12,
    xl: 8,
}

const reviewCardStyle = {
    backgroundColor: offWhite,
}

const bookingDatePickerLabel = {
    display: 'inline-flex',
    alignItems: 'center',
    marginRight: '4px',
}

const titleHeader = {
    marginBottom: '24px',
}

const redAsterisk = {
    color: 'red',
    marginRight: '4px',
}

const emptyReportCheckBox = {
     flexFlow: 'nowrap'
}

const labelColSize = {
    xs: 24,
    md: 12
}

const dataColSize = {
    xs: 24,
    md: 12,
}

const filterFormColLayout = {
  xs: 24,
  sm: 12,
  md: 8,
  lg: 8
};

const filterFormActionsColLayout = {
  xs: 24,
  sm: 24,
  md: 24,
  lg: 24
};

export {
    formStandaloneLayout,
    formCompanyDataLayout,
    formItemSubmitButtonStyle,
    formInCardLayout,
    formItemFullWidth,
    inlineButton,
    bookingListGridStyle,
    listGridStyle,
    jailListGridStyle,
    staffActionColSize,
    formItemEditorStyle,
    cardsGridColumn,
    reviewCardStyle,
    bookingDatePickerLabel,
    titleHeader,
    redAsterisk,
    emptyReportCheckBox,
    labelColSize,
    dataColSize,
    filterFormColLayout,
    filterFormActionsColLayout
};
